export default {
  //时间格式化
  formatDate(date) {
    if (!date) {
      return "--";
    }
    var now = new Date(date);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }
    return year + "/" + month + "/" + date;
  },
  //时间格式化
  formatDate1(date) {
    if (!date) {
      return "--";
    }
    var now = new Date(date);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }
    return year + "-" + month + "-" + date;
  },
  //时间格式化
  formatTime(date) {
    if (!date) {
      return "--";
    }
    var now = new Date(date);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var h = now.getHours();
    var mm = now.getMinutes();
    var s = now.getSeconds();
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }
    if (h < 10) {
      h = "0" + h;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    if (s < 10) {
      s = "0" + s;
    }
    return year + "-" + month + "-" + date + " " + h + ":" + mm + ":" + s;
  },
  //时间格式化
  formatDateWeek(date) {
    if (!date) {
      return "--";
    }
    var now = new Date(date);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var week = now.getDay();
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }

    return month + "月" + date + "日     " + changeWeek(week);
  }
};

function changeWeek(week) {
  let tmpnewchar = "";
  switch (week) {
    case 0:
      tmpnewchar = "星期日";
      break;
    case 1:
      tmpnewchar = "星期一";
      break;
    case 2:
      tmpnewchar = "星期二";
      break;
    case 3:
      tmpnewchar = "星期三";
      break;
    case 4:
      tmpnewchar = "星期四";
      break;
    case 5:
      tmpnewchar = "星期五";
      break;
    case 6:
      tmpnewchar = "星期六";
      break;
  }
  return tmpnewchar;
}
